import React from 'react';

import { i18n } from '@lt/localization';
import FreeWiFiIcon from '@lt/components/icons-react/hotel-facts/WifiFree';
import PaidWiFiIcon from '@lt/components/icons-react/hotel-facts/WifiPaid';
import FreeWiFiLobbyIcon from '@lt/components/icons-react/hotel-facts/WifiLobbyFree';
import PaidWiFiLobbyIcon from '@lt/components/icons-react/hotel-facts/WifiLobbyPaid';
import HotelFeature from '../HotelFeature';

export const WIFI_TYPES = {
  FREE: {
    Icon: <FreeWiFiIcon />,
    label: i18n.t('hotelcard.facts.wifi.everywhere'),
  },
  LOBBY_FREE: {
    Icon: <FreeWiFiLobbyIcon />,
    label: i18n.t('hotelcard.facts.wifi.lobby'),
  },
  PAID: {
    Icon: <PaidWiFiIcon />,
    label: i18n.t('hotelcard.facts.wifi.paid_label'),
  },
  LOBBY_PAID: {
    Icon: <PaidWiFiLobbyIcon />,
    label: i18n.t('hotelcard.facts.wifi.lobby'),
  },
  LOBBY_UNKNOWN: {
    Icon: <FreeWiFiLobbyIcon />,
    label: i18n.t('hotelcard.facts.wifi.lobby'),
  },
};

type WifiTypeFeatureProps = {
  value: string | null;
  isMobile: boolean;
};

const WifiTypeFeature = ({ value, isMobile }: WifiTypeFeatureProps) => {
  if (!value) {
    return null;
  }

  const wifiType = WIFI_TYPES[value && value.toUpperCase()];

  if (!wifiType) {
    return null;
  }
  const { Icon, label } = wifiType;
  return <HotelFeature Label={label} Icon={Icon} isMobile={isMobile} />;
};

export default WifiTypeFeature;
